import { useLocation } from 'react-router-dom'

import { track } from '@amplitude/analytics-browser'

import subscriptions from 'modules/billing/store/collections/subscriptions'

interface EventPayload {
  page_path: string
  page_url: string
  request_type: string
  from: string
  company_plan: string[]
  call_type?: string
}

const useCallPageEvents = ({ from, callType }: { from: string; callType?: string }) => {
  const { pathname } = useLocation()
  const currentSubscription = subscriptions.current

  const eventPayload: EventPayload = {
    page_path: pathname,
    page_url: window.location.href,
    request_type: 'Contact CX',
    from: from,
    company_plan: currentSubscription.inFreeTrial
      ? ['free']
      : currentSubscription.chargebeeSubscriptionItems.map((e) => e.item_price_id),
    ...(callType ? { call_type: callType } : {}),
  }

  const eventEmitter = (event: string) => {
    track(event, { ...eventPayload })
  }

  return { eventEmitter }
}

export default useCallPageEvents
